import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Button } from './ui/button';

export function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    const label = theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему';
    return (
        <Button type="button" variant="outline" size="icon" onClick={toggleTheme}
            aria-label={label} title={label} aria-pressed={theme === 'dark'} className="shrink-0">
            {theme === 'dark' ? <Sun className="h-4 w-4" aria-hidden="true" /> : <Moon className="h-4 w-4" aria-hidden="true" />}
        </Button>
    );
}

export function PageThemeToggle() {
    const { pathname } = useLocation();
    if (pathname.startsWith('/payment/')) return null;
    if (/\/(dashboard|appeals|conversion|payments-history|topups-history|sandbox|integration|settings|api-test|appeal-test)\/?$/.test(pathname)) return null;
    return <div className="flex justify-end px-4 py-2 sm:px-8 bg-background"><ThemeToggle /></div>;
}
